// src/services/animationService.js
import * as THREE from 'three';

class AnimationService {
    constructor() {
        this.animatedObjects = new Set();
        this.clock = new THREE.Clock();
    }

    add(object) {
        if (object.userData.animationMixer) {
            this.animatedObjects.add(object);
        }
    }

    remove(object) {
        this.animatedObjects.delete(object);
    }

    // The start method is no longer needed when using an external render loop.
    // start() {
    //     this.clock.start();
    //     this.update();
    // }

    // Renamed from 'animate' and removed requestAnimationFrame to allow external control.
    update() {
        const deltaTime = this.clock.getDelta();
        for (const object of this.animatedObjects) {
            // Ensure mixer exists before updating
            if (object.userData.animationMixer) {
                object.userData.animationMixer.update(deltaTime);
            }
        }
    }
}

const animationService = new AnimationService();
export default animationService;